'use es6';

import { useEffect, useCallback, useRef } from 'react';
import SnippetPopoverBody from 'rich-text-lib/components/snippet/SnippetPopoverBody';
import useInlineTarget from '../utils/hooks/useInlineTarget';
import TinyMcePopover from './TinyMcePopover';
import withPopoverModeState from './withPopoverModeState';
import { jsx as _jsx } from "react/jsx-runtime";
function SnippetPopoverManager({
  editor,
  onInsert,
  fetchSnippets,
  onOpenChange
}) {
  const {
    inlineTarget,
    setInlineTarget,
    initInlineTarget
  } = useInlineTarget(editor, null);
  const lastTarget = useRef(inlineTarget);
  useEffect(() => {
    lastTarget.current = inlineTarget;
  });
  useEffect(() => {
    onOpenChange(!!inlineTarget);
  }, [onOpenChange, inlineTarget]);
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setInlineTarget(null);
    }
  }, [setInlineTarget]);
  const handleInsert = (...args) => {
    handleRemove();
    onInsert(...args);
  };
  useEffect(() => {
    const handleOpenPopover = () => {
      if (lastTarget.current) {
        handleRemove();
      } else {
        initInlineTarget();
      }
    };
    editor.on('OpenSnippetPopover', handleOpenPopover);
    return () => editor.off('OpenSnippetPopover', handleOpenPopover);
  }, [editor, initInlineTarget, handleRemove]);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    editor: editor,
    "data-test-id": "snippet-popover",
    open: !!inlineTarget,
    target: inlineTarget,
    placement: "bottom",
    onOpenChange: handleRemove,
    onRemove: handleRemove,
    content: /*#__PURE__*/_jsx(SnippetPopoverBody, {
      onInsert: handleInsert,
      fetchSnippets: fetchSnippets
    })
  });
}
export default withPopoverModeState(SnippetPopoverManager);